import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

export const EMPTY_INVOICE = {
    tarifa_atr: '', geo_zone: 'PENINSULA', fecha_inicio: '', fecha_fin: '', dias_facturados: '',
    consumos_kwh: {}, potencias_kw: {}, precios_energia_eur_kwh: {}, precios_potencia: {},
    unidad_precio_potencia: '', ie_pct: '', iva_pct: '', total_factura_eur: '',
    bono_social_eur: '', alquiler_eur: '', excedentes_kwh: 0, total_descuentos_eur: 0,
};

export const ELECTRIC_TOLLS = ['2.0TD', '3.0TD', '6.1TD', '6.2TD', '6.3TD', '6.4TD'];
export function invoiceFieldLabel(field) {
    const labels = { tarifa_atr: 'Peaje', geo_zone: 'Zona', fecha_inicio: 'Inicio del periodo', fecha_fin: 'Fin del periodo',
        dias_facturados: 'Días facturados', ie_pct: 'Impuesto eléctrico', iva_pct: 'IVA', total_factura_eur: 'Importe total',
        alquiler_eur: 'Alquiler del periodo', bono_social_eur: 'Bono social del periodo', consumos_kwh: 'Consumo',
        potencias_kw: 'Potencia', reparto_consumo_pct: 'Reparto del consumo', consumo_total_kwh: 'Consumo total',
        precios_energia_eur_kwh: 'Precio de energía', precios_potencia: 'Precio de potencia',
        unidad_precio_potencia: 'Unidad del precio de potencia', excedentes_kwh: 'Excedentes',
        total_descuentos_eur: 'Descuentos', precio_excedentes_eur_kwh: 'Precio de excedentes' };
    const [key, period] = field.split('.');
    return `${labels[key] || 'Datos de la factura'}${period ? ` ${period}` : ''}`;
}

// One configuration request per session. Nothing appears when the server flag is off.
const configurationRequests = new Map();
export function useInvoiceV2Enabled(allowed = true) {
    const { token } = useAuth() || {};
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        let active = true;
        setEnabled(false);
        if (allowed && token) {
            if (!configurationRequests.has(token)) {
                configurationRequests.clear();
                configurationRequests.set(token, fetch('/api/v2/invoices/config', {
                    headers: { Authorization: `Bearer ${token}` },
                }).then(async response => response.ok && (await response.json()).enabled === true).catch(() => false));
            }
            configurationRequests.get(token).then(value => { if (active) setEnabled(value); });
        }
        return () => { active = false; };
    }, [allowed, token]);
    return enabled;
}

export function prepareReviewedInput(draft, { referenceMode } = {}) {
    const result = { ...draft };
    if (result.reparto_consumo_pct == null) delete result.consumo_total_kwh;
    // Unknown rent and social-fund charges need confirmation, including zero.
    ['bono_social_eur', 'alquiler_eur'].forEach(key => {
        if (result[key] === '' || result[key] == null) result[key] = null;
    });
    ['excedentes_kwh', 'total_descuentos_eur', 'precio_excedentes_eur_kwh'].forEach(key => {
        if (result[key] === '' || result[key] == null) result[key] = 0;
    });
    if (result.total_factura_eur === '') result.total_factura_eur = null;
    if (referenceMode === 'precios') result.total_factura_eur = null;
    if (result.dias_facturados === '') result.dias_facturados = null;
    const number = value => typeof value === 'string' && value.trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : value;
    ['dias_facturados', 'consumo_total_kwh', 'ie_pct', 'iva_pct', 'total_factura_eur', 'bono_social_eur', 'alquiler_eur',
        'excedentes_kwh', 'total_descuentos_eur', 'precio_excedentes_eur_kwh'].forEach(key => {
        if (key in result) result[key] = number(result[key]);
    });
    ['consumos_kwh', 'potencias_kw', 'precios_energia_eur_kwh', 'precios_potencia', 'reparto_consumo_pct'].forEach(key => {
        if (result[key]) result[key] = Object.fromEntries(Object.entries(result[key]).map(([period, value]) => [period, number(value)]));
    });
    return result;
}
